import * as React from "react";
import PropTypes from "prop-types";
import SexyButton from "../../theme/SexyButton";
import PurchaseDialog from "./PurchaseDialog";

/*
 * PurchaseModal provides a generic modal purchase experience. It requires a
 * "purchase" object that provides at the minimum:
 *
 * {
 *   type: The type of purchase, for backend routing of purchase,
 *   name: The business name (id) of item being purchased,
 *   title: The display name of purchase,
 *   description: Longer description about purchase,
 *   price: Price to display,
 *   autographPurchaseId: Optional autographPurchaseId to associate with existing order,
 *   content: Optional modal content to display before purchase form,
 *   billingAddress: Boolean to show option to enter billingAddress,
 *   shippingAddress: Boolean to show option to enter shippingAddress
 * }
 *
 */
export default function PurchaseModal({ purchase, onPurchase }) {
  const [open, setOpen] = React.useState(false);

  const onClose = React.useCallback(
    (updates) => {
      setOpen(false);
      if (onPurchase) onPurchase(updates);
    },
    [onPurchase],
  );

  return (
    <>
      <SexyButton onClick={() => setOpen((s) => !s)}>Purchase</SexyButton>
      {open && (
        <PurchaseDialog open={open} onClose={onClose} purchase={purchase} />
      )}
    </>
  );
}

PurchaseModal.propTypes = {
  purchase: PropTypes.shape({
    type: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    amount: PropTypes.number.isRequired,
    autographPurchaseId: PropTypes.number,
    content: PropTypes.node,
    billingAddress: PropTypes.bool,
    shippingAddress: PropTypes.bool,
  }),
  onPurchase: PropTypes.func,
};

export const PURCHASE_TYPES = {
  ADDON_PURCHASE: "addonPurchase",
};
